/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_H_WeInputs */

const en_cp_cmp_h_we = /** @type {(inputs: Cp_Cmp_H_WeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What Bystep adds`)
};

const id_cp_cmp_h_we = /** @type {(inputs: Cp_Cmp_H_WeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang Bystep tambahkan`)
};

/**
* | output |
* | --- |
* | "What Bystep adds" |
*
* @param {Cp_Cmp_H_WeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_h_we = /** @type {((inputs?: Cp_Cmp_H_WeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_H_WeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_h_we(inputs)
	return en_cp_cmp_h_we(inputs)
});